import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center py-16"
};
const _hoisted_2 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3"
};
const _hoisted_3 = {
  class: "border-b border-slate-100 bg-[radial-gradient(circle_at_top_right,rgba(59,130,246,0.12),transparent_34%),linear-gradient(180deg,#ffffff_0%,#f8fafc_100%)] px-5 py-4"
};
const _hoisted_4 = {
  class: "flex items-start justify-between gap-4"
};
const _hoisted_5 = {
  class: "min-w-0"
};
const _hoisted_6 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_7 = {
  key: 0,
  class: "rounded-full status-badge is-neutral px-2.5 py-1 text-[11px] font-medium"
};
const _hoisted_8 = {
  class: "mt-3 line-clamp-2 min-h-[3.5rem] text-base font-semibold leading-7 text-slate-900"
};
const _hoisted_9 = {
  class: "flex flex-1 flex-col px-5 py-5"
};
const _hoisted_10 = {
  class: "whitespace-pre-wrap break-words text-sm leading-6 text-slate-600"
};
const _hoisted_11 = {
  class: "mt-4 flex items-center gap-2 text-xs text-slate-500"
};
const _hoisted_12 = {
  class: "truncate"
};
const _hoisted_13 = {
  class: "mt-5 grid grid-cols-3 gap-2.5"
};
const _hoisted_14 = {
  class: "rounded-2xl border border-slate-100 bg-slate-50/80 px-3 py-3"
};
const _hoisted_15 = {
  class: "mt-2 text-sm font-semibold leading-5 text-slate-800"
};
const _hoisted_16 = {
  class: "rounded-2xl border border-slate-100 bg-slate-50/80 px-3 py-3"
};
const _hoisted_17 = {
  class: "mt-2 text-sm font-semibold leading-5 text-slate-800"
};
const _hoisted_18 = {
  class: "rounded-2xl border border-orange-100 bg-orange-50/90 px-3 py-3"
};
const _hoisted_19 = {
  class: "mt-2 text-lg font-semibold leading-5 text-orange-600"
};
const _hoisted_20 = {
  class: "mt-auto flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 px-5 py-4"
};
const _hoisted_21 = {
  class: "text-xs text-slate-400"
};
const _hoisted_22 = {
  class: "flex items-center gap-2"
};
const _hoisted_23 = ["disabled", "onClick"];
const _hoisted_24 = {
  key: 2,
  class: "flex flex-col items-center justify-center rounded-xl border border-slate-200 bg-white py-16 shadow-sm"
};
const _hoisted_25 = {
  class: "flex-1 overflow-y-auto bg-slate-50 px-4 py-4 md:px-6 md:py-6"
};
import { getCurrentInstance, onMounted, reactive, ref } from 'vue';
import AppModal from '@/components/AppModal.vue';
// import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import ReminderDefinitionList from '@/views/reminder/ReminderDefinitionList.vue';
import { getMyReminderTaskPage } from '@/api/reminder';
import { useReminderToast } from '@/composables/useReminderToast';
import { chooseReminderTaskAction, reminderTaskActionMessage } from '@/utils/reminderTaskProcess';

// const router = useRouter()

export default {
  __name: 'MyReminderTaskList',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const {
      isReminderSuppressed,
      processReminder
    } = useReminderToast();
    const loading = ref(false);
    const list = ref([]);
    const definitionModalVisible = ref(false);
    const filters = reactive({
      bizType: 'CUSTOM_REMINDER'
    });
    const pagination = ref({
      current: 1,
      size: 10,
      total: 0,
      pages: 0
    });
    function formatDateTime(value) {
      if (!value) return '';
      if (typeof proxy?.$formatDateTime === 'function') {
        return proxy.$formatDateTime(value);
      }
      return String(value).replace('T', ' ');
    }
    function taskStatusClass(status) {
      if (status === 'HANDLED' || status === 'CLOSED') return 'status-badge is-success';
      if (status === 'WAITING_RESPONSE' || status === 'WAITING') return 'status-badge is-info';
      if (status === 'EXPIRED') return 'status-badge is-rose';
      return 'status-badge is-warning';
    }
    function isTaskProcessDisabled(item) {
      return item?.status === 'HANDLED' || item?.status === 'CANCELLED' || item?.status === 'CLOSED';
    }
    function formatReminderCreator(item) {
      if (item?.creatorName) return item.creatorName;
      if (item?.creatorId) return `ID: ${item.creatorId}`;
      return '未知发起人';
    }
    async function fetchList() {
      loading.value = true;
      try {
        const result = await getMyReminderTaskPage({
          bizType: filters.bizType || undefined,
          pageNum: pagination.value.current,
          pageSize: pagination.value.size
        });
        list.value = (result?.records || []).filter(item => !isReminderSuppressed(item));
        pagination.value = {
          current: result?.current || pagination.value.current,
          size: result?.size || pagination.value.size,
          total: result?.total || 0,
          pages: result?.pages || 0
        };
      } catch (error) {
        ElMessage.error('获取提醒任务失败');
        console.error('获取提醒任务失败', error);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.value.current = 1;
      fetchList();
    }
    function handleReset() {
      filters.bizType = 'CUSTOM_REMINDER';
      pagination.value.current = 1;
      fetchList();
    }
    function handlePageChange(page) {
      pagination.value.current = page;
      fetchList();
    }
    function handlePageSizeChange(size) {
      pagination.value.size = size;
      pagination.value.current = 1;
      fetchList();
    }
    function openDefinitionModal() {
      definitionModalVisible.value = true;
    }
    function closeDefinitionModal() {
      definitionModalVisible.value = false;
    }

    // function viewDefinition(definitionId) {
    //   if (!definitionId) {
    //     ElMessage.warning('该任务未关联提醒定义')
    //     return
    //   }
    //   router.push(`/reminders/definitions?edit=${definitionId}`)
    // }

    async function handleProcessTask(item) {
      try {
        const result = await chooseReminderTaskAction(item);
        await processReminder(item.id, result.action, item, result);
        ElMessage.success(reminderTaskActionMessage(result.action));
        await fetchList();
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          ElMessage.error('处理提醒失败');
          console.error('处理提醒失败', error);
        }
      }
    }
    onMounted(() => {
      fetchList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal px-4 md:px-6 py-3"
        }, [_createElementVNode("div", {
          class: "flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between"
        }, [_createElementVNode("div", {
          class: "max-w-3xl"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "我的提醒"), _createElementVNode("p", {
          class: "mt-2 text-sm leading-6 text-slate-600"
        }, "查看分配给自己的提醒任务，支持延期提醒、标记完成和回到提醒定义页快速调整规则。")])])], -1)]))]),
        filters: _withCtx(() => [_createVNode(PageFilterBar, {
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchList
        }, {
          actions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:border-slate-300 hover:text-slate-900",
            onClick: openDefinitionModal
          }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.586 2.586a2 2 0 112.828 2.828L12 14.828l-4 1 1-4 9.586-9.242z"
          })], -1), _createTextVNode(" 我的定义 ", -1)]))])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filters.bizType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.bizType = $event),
            class: "form-select form-control-sm filter-bar-field",
            clearable: "",
            placeholder: "请选择业务类型"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "自定义提醒",
              value: "CUSTOM_REMINDER"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"])]),
        default: _withCtx(() => [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
          class: "h-8 w-8 animate-spin text-blue-500",
          fill: "none",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }), _createElementVNode("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        })], -1)]))])) : list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("article", {
            key: item.id,
            class: "group flex h-full flex-col overflow-hidden rounded-[24px] border border-slate-200/90 bg-white shadow-[0_12px_30px_rgba(15,23,42,0.06)] transition-all duration-200 hover:-translate-y-1 hover:border-blue-200 hover:shadow-[0_18px_40px_rgba(37,99,235,0.12)]"
          }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
            class: _normalizeClass([['status-badge', taskStatusClass(item.status)], "font-semibold"])
          }, _toDisplayString(item.statusDesc || item.status), 3), item.taskNo ? (_openBlock(), _createElementBlock("span", _hoisted_7, " #" + _toDisplayString(item.taskNo), 1)) : _createCommentVNode("", true)]), _createElementVNode("h3", _hoisted_8, _toDisplayString(item.title || '未命名提醒任务'), 1)])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString(item.content || '暂无提醒内容'), 1), _createElementVNode("div", _hoisted_11, [_cache[4] || (_cache[4] = _createElementVNode("svg", {
            class: "h-4 w-4 shrink-0 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.8",
            d: "M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.25a8.25 8.25 0 0115 0"
          })], -1)), _createElementVNode("span", _hoisted_12, "发起人：" + _toDisplayString(formatReminderCreator(item)), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[5] || (_cache[5] = _createElementVNode("p", {
            class: "text-xs text-slate-500"
          }, "首次提醒", -1)), _createElementVNode("p", _hoisted_15, _toDisplayString(formatDateTime(item.firstSendTime) || '-'), 1)]), _createElementVNode("div", _hoisted_16, [_cache[6] || (_cache[6] = _createElementVNode("p", {
            class: "text-xs text-slate-500"
          }, "下次提醒", -1)), _createElementVNode("p", _hoisted_17, _toDisplayString(formatDateTime(item.nextSendTime) || '暂无'), 1)]), _createElementVNode("div", _hoisted_18, [_cache[7] || (_cache[7] = _createElementVNode("p", {
            class: "text-xs text-orange-500"
          }, "发送次数", -1)), _createElementVNode("p", _hoisted_19, _toDisplayString(item.sendCount || 0), 1)])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(formatDateTime(item.nextSendTime || item.firstSendTime) || '-'), 1), _createElementVNode("div", _hoisted_22, [_createElementVNode("button", {
            type: "button",
            class: "btn-primary min-w-[104px]",
            disabled: isTaskProcessDisabled(item),
            onClick: $event => handleProcessTask(item)
          }, " 处理 ", 8, _hoisted_23)])])]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "h-10 w-10",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M9 12h6m-3-3v6m9 1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h4l2-2h8a2 2 0 012 2v11z"
        })])], -1)), _cache[9] || (_cache[9] = _createElementVNode("p", {
          class: "mt-5 text-sm text-slate-500"
        }, "当前没有可展示的提醒任务", -1)), _createElementVNode("button", {
          type: "button",
          class: "btn-primary mt-5",
          onClick: openDefinitionModal
        }, "前往创建提醒")])), pagination.value.pages > 1 ? (_openBlock(), _createBlock(AppPagination, {
          key: 3,
          class: "is-standalone",
          pagination: pagination.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true), _createVNode(AppModal, {
          visible: definitionModalVisible.value,
          size: "none",
          "panel-class": "h-[min(900px,calc(100vh-2rem))] max-w-[1400px] border border-slate-200",
          scrollable: false,
          onClose: closeDefinitionModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-start justify-between gap-4 border-b border-slate-200 bg-[linear-gradient(135deg,#f8fbff_0%,#ffffff_60%,#f8fafc_100%)] px-6 py-5"
          }, [_cache[11] || (_cache[11] = _createElementVNode("div", null, [_createElementVNode("h2", {
            class: "text-xl font-semibold text-slate-900"
          }, "提醒定义"), _createElementVNode("p", {
            class: "mt-1 text-sm text-slate-500"
          }, "在当前页面直接维护你的提醒定义，无需跳转离开任务列表。")], -1)), _createElementVNode("button", {
            type: "button",
            class: "inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition-colors hover:border-slate-300 hover:text-slate-900",
            onClick: closeDefinitionModal
          }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_25, [_createVNode(ReminderDefinitionList, {
            embedded: ""
          })])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};